import { render } from "./InputCheckMultiple.vue?vue&type=template&id=5d920b16"
import script from "./InputCheckMultiple.vue?vue&type=script&lang=js"
export * from "./InputCheckMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__